import type { SVGProps } from "react";
export interface TrashCheckIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TrashCheckIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TrashCheckIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.602 4.38a1.126 1.126 0 0 1 1.019 1.223l-1.103 12.133c-.069.753-.126 1.382-.213 1.894-.09.525-.224 1.015-.495 1.472a4.1 4.1 0 0 1-1.506 1.481l-.272.142c-.48.228-.98.319-1.51.36-.518.041-1.15.04-1.905.04h-3.234c-.756 0-1.387.001-1.904-.04-.465-.036-.906-.11-1.33-.28l-.18-.08a4.1 4.1 0 0 1-1.612-1.365l-.167-.258c-.27-.457-.406-.947-.495-1.472q-.065-.383-.113-.856l-.1-1.038L3.38 5.603l-.004-.116a1.125 1.125 0 0 1 2.23-.202l.016.112 1.103 12.135c.071.788.12 1.316.189 1.72.066.39.14.578.213.703l.159.229c.175.215.396.39.649.51l.112.045c.129.043.312.08.608.104.41.032.938.032 1.729.032h3.234c.791 0 1.32 0 1.729-.032.395-.031.589-.087.72-.15l.24-.137c.23-.155.425-.36.567-.6.075-.126.148-.314.214-.704.07-.404.118-.932.19-1.72L18.38 5.397a1.126 1.126 0 0 1 1.223-1.018Z"
      />
      <path
        fill={color}
        d="M14.704 10.205a1.125 1.125 0 0 1 1.59 1.59l-4.5 4.5c-.438.44-1.15.44-1.59 0l-2-2-.077-.085a1.125 1.125 0 0 1 1.583-1.583l.085.078L11 13.91zM13.585.875c.432.004.84.028 1.225.154l.306.118c.3.135.577.315.822.537l.143.142c.322.343.557.773.817 1.229l.755 1.32H21l.116.005a1.126 1.126 0 0 1 0 2.239L21 6.625H3a1.125 1.125 0 0 1 0-2.25h3.347l.974-1.704c.219-.374.442-.716.742-.987l.254-.207c.266-.194.56-.346.873-.448l.195-.054c.327-.079.67-.097 1.03-.1zm-2.728 2.25c-.565 0-.776.007-.884.023l-.084.02a1 1 0 0 0-.167.076l-.15.108a.9.9 0 0 0-.144.189l-.372.63-.118.204h6.123l-.117-.204c-.28-.49-.39-.67-.458-.756l-.059-.063a1 1 0 0 0-.15-.108l-.166-.077c-.092-.03-.216-.042-.968-.042z"
      />
    </svg>
  );
}
